import React, { Component } from 'react';

import PermissionGrid from './PermissionList/PermissionGrid'

/**
* Class LayerPermissionList
* LayerPermissionList view component
**/
class LayerPermissionList extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Gérer les permissions des couches</h2>
        <PermissionGrid ref={"gridPermission"} path="layerpermissions" objectPath="layerpermissions" synchronize={false} />
      </div>
		);
	}

}
export default LayerPermissionList;



// WEBPACK FOOTER //
// ./src/views/Search/LayerPermissionList.js